import { render } from "./LabelBox.vue?vue&type=template&id=37c9cea3&scoped=true"
import script from "./LabelBox.vue?vue&type=script&lang=js"
export * from "./LabelBox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LabelBox.vue?vue&type=style&index=0&id=37c9cea3&lang=scss&module=true"
cssModules["$style"] = style0
import "./LabelBox.vue?vue&type=style&index=1&id=37c9cea3&lang=scss&scoped=true"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-37c9cea3"]])

export default __exports__